import { Capacitor } from '@capacitor/core';
import { isNative, isIOS, isAndroid } from '../utils/native';
import { trackEvent } from '../utils/analytics';

export const APP_STORE_URL = 'https://apps.apple.com/app/id6760615646';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.wordlabyrinth.app';

const ASKED_KEY = 'wl_store_review_asked_at';
const ASK_EVERY_MS = 120 * 24 * 3600 * 1000;
const MIN_WINS = 3;

function readNumber(key) {
    try { return parseInt(localStorage.getItem(key) || '0', 10) || 0; } catch { return 0; }
}

// The OS review sheet: only in app builds that ship the plugin (1.3+), never after an opinion question.
export function canRequestStoreReview() {
    if (!isNative() || !Capacitor.isPluginAvailable('InAppReview')) return false;
    let askedAt = 0;
    try { askedAt = Date.parse(localStorage.getItem(ASKED_KEY) || '') || 0; } catch { /* ignore */ }
    return readNumber('wl_wins_total') >= MIN_WINS && Date.now() - askedAt > ASK_EVERY_MS;
}

export async function requestStoreReview(context) {
    if (!canRequestStoreReview()) return false;
    try {
        localStorage.setItem(ASKED_KEY, new Date().toISOString());
        const { InAppReview } = await import('@capacitor-community/in-app-review');
        await InAppReview.requestReview();
        trackEvent('Store Review Requested', { context, platform: Capacitor.getPlatform() });
        return true;
    } catch {
        return false;
    }
}

// Store page for a player who chooses to rate us (Options menu). Capacitor opens it in the store app.
export function storeReviewUrl() {
    if (isIOS()) return `${APP_STORE_URL}?action=write-review`;
    if (isAndroid()) return `${PLAY_STORE_URL}&showAllReviews=true`;
    return null;
}

// Web visitors on a phone get the matching store; desktop gets null.
export function storeUrlForThisDevice() {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    if (/iPhone|iPad|iPod/i.test(ua)) return APP_STORE_URL;
    if (/Android/i.test(ua)) return PLAY_STORE_URL;
    return null;
}
